module.exports = __webpack_public_path__ + "static/media/icon-5.6f37f8cc.png";